import { getGradientColor } from './colorUtils';

export function extractStopActivities(
  mapData,
  selectedTour,
  selectedStopIndex,
  showOnlyFirstVisits,
) {
  if (!mapData || !mapData.geo || !mapData.geo.features) {
    return [];
  }

  const stopActivities = [];

  mapData.geo.features.forEach((feature) => {
    if (
      feature.geometry.type === 'Point' &&
      feature.properties.stopLocation &&
      feature.properties.types &&
      feature.properties.routeId === selectedTour &&
      feature.properties.stopIndex === selectedStopIndex
    ) {
      if (showOnlyFirstVisits && !feature.properties.isFirstVisit) {
        return;
      }

      stopActivities.push({
        coordinates: feature.geometry.coordinates,
        activityIndex: feature.properties.activityIndex ?? 0,
        activityOrder: feature.properties.activityOrder ?? 0,
      });
    }
  });

  return stopActivities;
}

export function toLeafletCoordinates(coordinates) {
  return [coordinates[1], coordinates[0]];
}

export function createActivityLines(activities, selectedTour, selectedStopIndex) {
  if (activities.length < 2) {
    return [];
  }

  const lines = [];

  for (let i = 0; i < activities.length - 1; i++) {
    const start = activities[i];
    const end = activities[i + 1];

    const progress = activities.length > 2 ? i / (activities.length - 2) : 0;
    const color = getGradientColor(progress);

    lines.push({
      key: `stop-${selectedTour}-${selectedStopIndex}-activity-${i}`,
      positions: [toLeafletCoordinates(start.coordinates), toLeafletCoordinates(end.coordinates)],
      color,
    });
  }

  const first = activities[0];
  const last = activities[activities.length - 1];

  lines.push({
    key: `stop-${selectedTour}-${selectedStopIndex}-activity-close`,
    positions: [toLeafletCoordinates(last.coordinates), toLeafletCoordinates(first.coordinates)],
    color: getGradientColor(1),
  });

  return lines;
}

export function calculateActivityLines(
  mapData,
  selectedTour,
  selectedStopIndex,
  showOnlyFirstVisits,
) {
  const activities = extractStopActivities(
    mapData,
    selectedTour,
    selectedStopIndex,
    showOnlyFirstVisits,
  );

  if (activities.length < 2) {
    return [];
  }

  activities.sort((a, b) => a.activityIndex - b.activityIndex);

  return createActivityLines(activities, selectedTour, selectedStopIndex);
}
